module.exports = __webpack_public_path__ + "img/6.9af257af.png";